export default "__VITE_ASSET__05cdd212__"